import { cn } from "@/utils/cnHelper";
import React from "react";

export type SubtitleProps = {
  children: React.ReactNode;
  as?: "p" | "span";
  variant?: "default" | "hero" | "feature" | "cta";
  className?: string;
};

export default function Subtitle({ children, as = "p", variant = "default", className }: SubtitleProps) {
  const Tag = as as keyof JSX.IntrinsicElements;

  const classes = cn(
    "tw-font-medium tw-text-[var(--foreground-color-muted)]",
    variant === "default" && "!tw-text-base sm:!tw-text-lg lg:!tw-text-xl tw-text-pretty",
    variant === "hero" && "!tw-text-lg sm:!tw-text-xl/8 tw-text-balance",
    variant === "feature" && "!tw-text-base sm:!tw-text-lg lg:!tw-text-xl/8 tw-text-pretty",
    variant === "cta" && "!tw-text-base sm:!tw-text-lg lg:!tw-text-xl/8 tw-text-balance",
    className
  );
  return <Tag className={classes}>{children}</Tag>;
}
